module.exports = __webpack_public_path__ + "static/media/checklist.156d97bf.svg";